import Spinner from '@/atoms/loader/Spinner';
import EventTile from '@/organisms/EventTile';
import { formatISO9075 } from 'date-fns';
import { useEvents } from 'hooks/queries/events';
import { useMemo } from 'react';
import { useCmsData } from 'utils/cms';
import { getCMSEventType } from 'utils/events';
import ModalClassicLayout from '../../layout/Classic';

const ShopEventsListModal = ({
  closeModal,
  organizerId,
  storeName,
}: {
  closeModal: () => void;
  organizerId: string;
  storeName: string;
}) => {
  const {
    acf: { eventType },
  } = useCmsData();

  const now = useMemo(() => formatISO9075(new Date(), { representation: 'date' }), []);

  const {
    queryResult: { data, isLoading },
  } = useEvents({ organizer: organizerId, 'order[startDateTime]': 'asc', 'endDateTime[after]': now });

  return (
    <ModalClassicLayout closeModal={closeModal} title={storeName}>
      {isLoading && <Spinner />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {data?.['hydra:member']?.map((event) => (
          <EventTile
            key={event.id}
            event={event}
            eventType={getCMSEventType(eventType, event.eventType?.['@id'])}
            href={`events/${event.id}`}
          />
        ))}
      </div>
    </ModalClassicLayout>
  );
};
export default ShopEventsListModal;
